import { useContext } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createActionsHook, createStateHook } from '@atlassian/react-sweet-state';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { Store, LifecycleContext } from './index.tsx';

const useSearchKeyContext = () => useContext(LifecycleContext).searchKey;
const useIsFetchingContext = () => useContext(LifecycleContext).isFetching;
const useIsFetchingViewContext = () => useContext(LifecycleContext).isFetchingView;
const useIsNetworkErrorContext = () => useContext(LifecycleContext).isNetworkError;
const useIsRefreshingContext = () => useContext(LifecycleContext).isRefreshing;

const useSearchKeyRSS = createStateHook(Store, { selector: (state) => state.searchKey });
const useIsFetchingRSS = createStateHook(Store, { selector: (state) => state.isFetching });
const useIsFetchingViewRSS = createStateHook(Store, {
	selector: (state) => state.isFetchingView,
});
const useIsNetworkErrorRSS = createStateHook(Store, {
	selector: (state) => state.isNetworkError,
});
const useIsRefreshingRSS = createStateHook(Store, { selector: (state) => state.isRefreshing });

export const useSearchKey = functionWithCondition(
	() => fg('jira_nin_refetch_state_concurrency_fix'),
	useSearchKeyContext,
	useSearchKeyRSS,
);
export const useIsFetching = functionWithCondition(
	() => fg('jira_nin_refetch_state_concurrency_fix'),
	useIsFetchingContext,
	useIsFetchingRSS,
);
export const useIsFetchingView = functionWithCondition(
	() => fg('jira_nin_refetch_state_concurrency_fix'),
	useIsFetchingViewContext,
	useIsFetchingViewRSS,
);
export const useIsNetworkError = functionWithCondition(
	() => fg('jira_nin_refetch_state_concurrency_fix'),
	useIsNetworkErrorContext,
	useIsNetworkErrorRSS,
);
export const useIsRefreshing = functionWithCondition(
	() => fg('jira_nin_refetch_state_concurrency_fix'),
	useIsRefreshingContext,
	useIsRefreshingRSS,
);

export const useTotalIssueCount = createStateHook(Store, {
	selector: (state) => state.totalIssueCount,
});

export const useTotalIssueCountIsFetching = createStateHook(Store, {
	selector: (state) => state.totalIssueCountIsFetching,
});

export const useTotalIssueCountIsError = createStateHook(Store, {
	selector: (state) => state.totalIssueCountIsError,
});

export const useIssueSearchActions = createActionsHook(Store);
